const getOffset = require('document-offset');
import { throttle, debounce } from 'throttle-debounce';

export default class Stickyd{
    constructor(options){
        /*
        * Configurable options
        */
        this.minWidth = options.minWidth || 970;
        this.containerEl = options.containerEl || document.querySelector('[data-stickyd-container]');
        this.stickyEl = options.el || document.querySelector('[data-stickyd]');
        this.offset = options.offset || 0;
        this.bodyClass = options.bodyClass || 'is-aside-sticky';
        this.stickyClass = options.stickyClass || 'is-sticky';

        if (!this.stickyEl) {
          return ;
        }

        /*
        * Solid values
        */
        this.startPoint = Math.floor(getOffset(this.stickyEl).top - this.offset);
        this.endPoint = Math.floor(getOffset(this.containerEl).top + this.containerEl.clientHeight - this.stickyEl.clientHeight - this.offset);
        //console.log(this.endPoint)
        this.isInit = false;
        this.isAtBottom = false;
        this.isSticky = false;

        /*
        * Eventlisteners
        */
        this.handleResize = this.handleResize.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        if(window.innerWidth < this.minWidth){
            window.addEventListener('resize', debounce(100, this.handleResize))
        }else{
            window.addEventListener('scroll', throttle(0, this.handleScroll))
            this.isInit = true;
        };
    };



    /*
     * Window events
    */
    handleScroll(){

        /*
         * Handle way down
        */
        if(window.pageYOffset >= this.startPoint && !this.isSticky){
            document.body.classList.add(this.bodyClass);
            this.stickyEl.classList.add(this.stickyClass);
            this.isSticky = true;
            this.stickyEl.style.top = this.offset+'px';

        }else if(window.pageYOffset < this.startPoint && this.isSticky){
            document.body.classList.remove(this.bodyClass);
            this.stickyEl.classList.remove(this.stickyClass);
            this.stickyEl.removeAttribute('style');
            this.isSticky = false;
        }

        /*
         * Handle way up
        */
        if(window.pageYOffset > this.endPoint + this.offset && !this.isAtBottom){
            this.stickyEl.style.position = 'absolute';
            this.stickyEl.style.top = this.endPoint - this.offset * 2 +'px';
            this.isAtBottom = true;
        }else if(window.pageYOffset < this.endPoint + this.offset && this.isAtBottom){
            this.stickyEl.removeAttribute('style');
            this.stickyEl.style.top = this.offset+'px';
            this.isAtBottom = false;
        }

    }

    handleResize(){
        if(window.innerWidth >= this.minWidth && !this.isInit){
            window.addEventListener('scroll', throttle(50, this.handleScroll));
        }

        this.startPoint = Math.floor(getOffset(this.containerEl).top - this.offset);
        this.endPoint = Math.floor(getOffset(this.containerEl).top + this.containerEl.clientHeight - this.stickyEl.clientHeight);
    }
}
